import { VpvEvent } from "./vpv.dto";
import { INITIAL_SALE_EVENT_CONTEXT } from "../../../constants";
import { validateSessionByCookie } from "../../services/cookies";

export const handleVpvEvent = (data, rest: any) => {
  const hm = getHm(data);
  const full = fullTripIata(data);

  const {
    env: environment,
    isApp: app,
    isCorpo: corp,
  } = JSON.parse(localStorage.getItem(INITIAL_SALE_EVENT_CONTEXT) || "{}");

  const eventData: VpvEvent = {
    event: "vpv",
    event_params: {
      app: data.app ?? app,
      environment: data.environment ?? environment,
      corp: data.corp ?? corp,
      page_path: data.page_path ?? `/${hm}/flujo-compra/${data.path}`,
      micrositio: data.micrositio ?? "booking",
      page_type: data.section,
      homemarket: hm,
      negocio: "retail",
      buy_instance: data.buy_instance || "IS",
      login: validateSessionByCookie(),
      initial_date: data.queryStore.departureDate,
      end_date: data.queryStore.arrivalDate,
      from_iata: data.queryStore.origin,
      to_iata: data.queryStore.destination,
      trip_type: data.queryStore.flightType === "RT" ? "roundtrip" : "oneway",
      passengers_adult: parseInt(data.queryStore.ADT),
      passengers_child: data.queryStore.CHD ? parseInt(data.queryStore.CHD) : 0,
      passengers_infant: data.queryStore.INF
        ? parseInt(data.queryStore.INF)
        : 0,
      passengers_pet: data.queryStore.PET ? parseInt(data.queryStore.PET) : 0,
      pax:
        parseInt(data.queryStore.ADT) +
        parseInt(data.queryStore.CHD || "0") +
        parseInt(data.queryStore.INF || "0"),
      full_trip: data.fullTrip ?? full, // to not break the vpv of andrea
      exchange_rate: null,
      ...(data.origin && { origin: data.origin }),
      flights_available: validateFlightsAvailable(),
      ...rest,
    },
  };

  return eventData;
};

export const getHm = (data) => {
  const url = data.hm;
  const hm = url.split("/")[2];

  return hm;
};

const fullTripIata = (data) => {
  const fullTrip =
    data.queryStore.flightType === "RT"
      ? `${data.queryStore.origin}-${data.queryStore.destination},${data.queryStore.destination}-${data.queryStore.origin}`
      : `${data.queryStore.origin}-${data.queryStore.destination}`;
  return fullTrip;
};

const validateFlightsAvailable = () => {
  const getAlternatives = localStorage.getItem("alternativesHandle");
  if(getAlternatives){
    const alternatives = JSON.parse(getAlternatives);
    const {departureDateSearched,returnDateSearched} = alternatives;
    if(departureDateSearched.length > 0 || returnDateSearched.length > 0){
      return false;
    }
  }
  return true;
}
